export var StatusValues = ['active', 'canceled', 'mail_sent'];
export var ProcessingValues = [
    'washed',
    'honey',
    'natural',
    'experimental',
];
export var VarietyValues = ['special', 'standard'];
